import { IFundingOrganization, IOrganization, IRor } from '@vivli/features/organizations/infrastructure/interface';
import { Color, Size } from '@vivli/shared/theme';
import { LinkFieldComponent, ReadOnlyFieldComponent, TextFormFieldComponent } from '@vivli/shared/components';
import { CSSProperties } from 'react';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { useModalApiContext } from '@vivli/core/infrastructure/context';
import { useOrganizationDetailsContext } from '@vivli/features/organizations/infrastructure/context';
import { AdminHeaderButtonView } from '@vivli/shared/views';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const detailContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    width: '70%',
    minWidth: '350px',
};

const rorDetailContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: 50,
    alignItems: 'center',
};

const fieldBodyStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    fontSize: Size.FontSize.Large,
    flexWrap: 'wrap',
};

const valueStyle: CSSProperties = {
    fontWeight: Size.FontWeight.SemiBold,
};

const labelStyle: CSSProperties = {
    color: Color.DARK_GRAY,
    marginRight: '10px',
};

const fiveAcrossStyleWithHeight: CSSProperties = {
    flex: '1 1 18',
    maxWidth: '18%',
    marginTop: '-5px',
    height: '87px',
    boxShadow: Size.BOX_SHADOW,
};

const fieldStyle: CSSProperties = { marginRight: '15px' };

const fiveColStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    columnGap: '20px',
};

interface RorComponentProps {
    ror: IRor | IFundingOrganization;
    isFundingOrg?: boolean;
    baseFormField?: string;
    fundingOrgIndex?: number;
    canModify?: boolean;
    baseOrganization?: IOrganization;
}

export const RorComponent = ({ ror, isFundingOrg, fundingOrgIndex, canModify, baseFormField, baseOrganization }: RorComponentProps) => {
    const orgContext = useOrganizationDetailsContext();
    const formField = `fundingOrganizations[${fundingOrgIndex}].grantId`;
    const grantTitle = baseFormField ? `${baseFormField}.${formField}` : formField;
    const rorUrl = `${ror?.rorId}`;
    const rorParentUrl = `${ror?.parentRorId}`;
    const hasParentUrl = ror?.parentRorId !== null && ror?.parentRorId !== undefined && ror?.parentRorId !== '';
    //TODO PERMFE - redo with permissions+
    const { hasPermission } = useActiveUserContext();
    const canEdit = hasPermission(PermissionsEnum.CreateOrg);
    const modalService = useModalApiContext();
    const noRor = !ror || ror === undefined || ror?.rorId === null || ror?.rorId === undefined || ror?.rorId === '';

    const handleClick = () => {
        modalService.confirm('Are you sure you want to clear the ROR information?', {
            title: 'Clear ROR Information',
            onConfirm: () => {
                const rorInfo = {
                    rorId: '',
                    rorName: '',
                    parentRorId: '',
                    parentRorName: '',
                };
                const updatedOrg = { ...baseOrganization };
                updatedOrg.rorInformation = rorInfo;
                orgContext.handleSave(updatedOrg);
            },
        });
    };

    return (
        <div style={{ width: '98%' }}>
            {!isFundingOrg && <div>ROR INFORMATION</div>}
            <div style={{ width: '100%' }}>
                {!isFundingOrg && (
                    <div style={fiveColStyle}>
                        <ReadOnlyFieldComponent label={'Ror Name'} readonly={true} text={ror?.rorName} />
                        <LinkFieldComponent linkTitle={ror?.rorId} linkContent={ror?.rorId} label={'Ror ID'} />
                        <ReadOnlyFieldComponent label={'Ror Parent Name'} readonly={true} text={ror?.parentRorName} />
                        <LinkFieldComponent linkTitle={ror?.parentRorId} linkContent={ror?.parentRorId} label={'Ror Parent ID'} />
                        <div style={{ display: 'grid', alignContent: 'center' }}>
                            {canEdit && <AdminHeaderButtonView title="Clear ROR Information" onClick={handleClick} isDisabled={noRor} />}
                        </div>
                    </div>
                )}

                {isFundingOrg && (
                    <div style={rorDetailContainerStyle}>
                        <div style={detailContainerStyle}>
                            <div style={fieldBodyStyle}>
                                <div style={fieldStyle}>
                                    <span style={labelStyle}>Ror Name:</span>
                                    <span style={valueStyle}>{ror?.rorName}</span>
                                </div>
                                <div style={fieldStyle}>
                                    <span style={labelStyle}>Ror ID:</span>
                                    <span style={valueStyle}>
                                        <a href={rorUrl} target="_blank">
                                            {rorUrl}
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <div style={fieldBodyStyle}>
                                <div style={fieldStyle}>
                                    <span style={labelStyle}>Parent Ror Name:</span>
                                    <span style={valueStyle}>{ror?.parentRorName}</span>
                                </div>
                                <div style={fieldStyle}>
                                    <span style={labelStyle}>Parent Ror ID:</span>
                                    {hasParentUrl && (
                                        <span style={valueStyle}>
                                            <a href={rorParentUrl} target="_blank">
                                                {rorParentUrl}
                                            </a>
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <TextFormFieldComponent
                            name={grantTitle}
                            label={'Grant or Contract Id'}
                            style={fiveAcrossStyleWithHeight}
                            readonly={!canModify && !canEdit}
                            truncateReadonly={false}
                            truncateLabel={true}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
